import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-greet-popup',
  templateUrl: './greet-popup.component.html',
  styleUrls: ['./greet-popup.component.scss']
})
export class GreetPopupComponent implements OnInit {

  btnText = 'Continue';

  constructor(private _dialogRef: MatDialogRef<GreetPopupComponent>) {
    this._dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    // this.close();
  }

  close() {
    // document.getElementById("btn").style.transition = '0.3s';
    // document.getElementById("btn").style.backgroundColor = '#ea4545';
    // document.getElementById("btn").style.color = 'white';
    // this.btnText = 'Applications Closed!';
    this._dialogRef.close();
  }

}
